import React, { useState, useEffect } from "react";
import moment from "moment";
import cookie from "react-cookies";
import { isIOS } from "react-device-detect";


import * as ROUTES from "../../constant/routes";

import install_mobile from "../../static/images/landingpage/install/install-mobile.png";




const AppInstall = ({ onFixHeight, search }) => {
	const [show, setShow] = useState(true);
	const [linkApp, setLinkApp] = useState(ROUTES.installApp);

	useEffect(() => {
		let urlApp; 
		if (isIOS) {
			setLinkApp(ROUTES.installIOS)
			urlApp = ROUTES.installIOS
		} else {
			setLinkApp(ROUTES.installAndroid)
			urlApp = ROUTES.installAndroid
		}
		
		const utmSrc = cookie.load("_utm_src") || "Web2App";
		if (utmSrc !== "") {
			setLinkApp(`${urlApp}&campaign=${utmSrc}&utm_source=${utmSrc}`);
		}
	}, []);

	const closeAppInstallHandle = (e) => {
		e.preventDefault();
		setShow(false);
	};


	const onIOSAppClick = () => {
		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		window.gtag("event", "INSTALL_APP_IOS", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: {source: utmSrc}
		});
		window.fbq("track", "INSTALL_APP_IOS");
	};

	const onAndroidAppClick = () => {
		//GA
		const utmSrc = cookie.load("_utm_src") || "web_directly";
		const utmExt = cookie.load("_utm_ext") || "no_label";
		window.gtag("event", "INSTALL_APP_ANDR", {
			event_category: utmSrc,
			event_label: utmExt,
			campaign: {source: utmSrc}
		});
		window.fbq("track", "INSTALL_APP_ANDR");
	};

	return (
		<div className={`bottom-fixed ${!show ? "hidden-install" : ""}`}>
			{/* {showCTA && (
				<a className="feedback" onClick={toggleWoayModal}>
					<img src={mini_game} />
					<span
						style={{
							position: "absolute",
							top: 0,
							right: 0,
							background: "#5fcf86",
							color: "#ffffff",
							fontSize: "26px",
							lineHeight: 0.5,
							padding: "4px",
							fontWeight: 800,
							borderRadius: "100%",
						}}
						onClick={closeCTAHandle}>
						×
					</span>
				</a>
			)} */}

			<a href={linkApp} target="_blank" onClick={isIOS ? onIOSAppClick : onAndroidAppClick} className="install-mobile">
				<img loading="lazy" src={install_mobile} />
				<div className="empty-div" />
				<p>
					Trải nghiệm trọn vẹn <br />
					Cùng ứng dụng Mioto{" "}
				</p>
				<a className="btn btn-black">
					Tải app
				</a>
				<p className="close" style={{ cursor: "pointer" }} onClick={closeAppInstallHandle}>
					×
				</p>
			</a>
		
		</div>
	);
};

export default AppInstall;


// const WoayModal = ({ showWoay, toggleWoayModal }) => {
// 	const closeWoay = () => {
// 		toggleWoayModal();
// 		let url = new URL(window.location.href);
// 		url.searchParams.delete("summer_game");
// 		url.searchParams.delete("wauth");
// 		window.location.replace(url.href);
// 	};

// 	return (
// 		<>
// 			{showWoay && (
// 				<div role="dialog">
// 					<div className="modal-backdrop fade in" />
// 					<div className="fade in modal" style={{ display: "block" }}>
// 						<div
// 							className="modal-woay modal-dialog modal-m"
// 							style={{
// 								backgroundImage: `url(${bg})`,
// 								backgroundRepeat: "no-repeat",
// 								backgroundPosition: "center",
// 								backgroundSize: "cover",
// 								borderRadius: "8px",
// 							}}>
// 							<div className="modal-content">
// 								<div className="modal-header">
// 									<button type="button" className="close" onClick={closeWoay}>
// 										<span aria-hidden="true">×</span>
// 										<span className="sr-only"></span>
// 									</button>
// 								</div>
// 								<div className="modal-body">
// 									<div className="banner-1">
// 										<a href="#" className="box-img-flex" aria-label="Link quảng cáo">
// 											<img src="https://app.woay.vn/w/c65fa21f-b3da-4e2a-9e53-ce4aca3b5be0/assets/9c3a0c65-e617-4309-948f-5e01d3d19934.png" />
// 										</a>
// 									</div>
// 									<div id="w-game">
// 										<div id="woay-game"></div>
// 									</div>
// 									<div className="ref-btn-ctn w-info-more-vongquay text-center">
// 										<div className="w-referral-text text-number-turns">
// 											Bạn còn
// 											<span className="w-r-times">00</span>
// 											lượt chơi
// 										</div>
// 										<div className="box-action">
// 											<div className="box-btn">
// 												<a className="wheel-btn w-random-pick-btn btn-play">Chơi ngay</a>
// 												<a className="wheel-btn btn-check-reward" style={{ display: "none" }}>
// 													Kiểm tra phần thưởng
// 												</a>
// 											</div>
// 											<a
// 												className="btn btn-link rule-game"
// 												target="_blank"
// 												href="https://drive.google.com/file/d/1OYIry5RlJCoXccd5EoCUURrHfcermy3t/view"
// 												style={{
// 													width: "100%",
// 													marginTop: "5px",
// 													fontSize: "0.875rem!important",
// 													textDecoration: "underline",
// 													borderBottom: 0,
// 												}}>
// 												Thể lệ chương trình
// 											</a>
// 										</div>
// 									</div>
// 									<Helmet>
// 										<link rel="stylesheet" href="https://woay.space/w/d5964318-ef49-4493-8290-c912065dbed8/style.css" />
// 										<script src="https://woay.space/w/d5964318-ef49-4493-8290-c912065dbed8/script.js"></script>
// 										{/* <link rel="stylesheet" href="https://woay.space/w/13dd6e7e-57c1-445d-a9af-8bcd27f53c39/style.css"/>
// 										<script src="https://woay.space/w/13dd6e7e-57c1-445d-a9af-8bcd27f53c39/script.js"></script> */}
// 									</Helmet>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			)}
// 		</>
// 	);
// };

// const WoayBanner = ({ showBanner, toggleWoayBanner, toggleWoayModal }) => {
// 	return (
// 		<Modal show={showBanner} onHide={toggleWoayBanner} dialogClassName="modal-m modal-woay modal-banner">
// 			<ModalBody>
// 				<img
// 					className="img-fluid pointer borderRadius-l"
// 					onClick={() => {
// 						toggleWoayModal(), toggleWoayBanner();
// 					}}
// 					src={banner}
// 				/>
// 			</ModalBody>
// 		</Modal>
// 	);
// };

// export const WoayGame = ({ onFixHeight, search }) => {
// 	const [showCTA, setShowCTA] = useState(true);
// 	const [showWoay, setShowWoay] = useState(false);
// 	const [showBanner, setShowBanner] = useState(false);

// 	const closeCTAHandle = (e) => {
// 		e.stopPropagation();
// 		setShowCTA(false);
// 	};

// 	useEffect(() => {
// 		// const cookieFirstTimeGame = cookie.load("_first_time_game");
// 		// const cookieSummerGame = cookie.load("_summer_game");
// 		// const cookieWauthGame = cookie.load("_wauth_game");

// 		// let query;
// 		// if (search !== "") {
// 		// 	query = queryString.parse(search);
// 		// }

// 		// if (cookieWauthGame !== undefined) {
// 		// 	toggleWoayModal();
// 		// 	cookie.remove("_wauth_game", { path: "/" });
// 		// 	cookie.remove("_wauth_game", { path: "/", domain: ".mioto.vn" });
// 		// }
// 		// else if (!cookieFirstTimeGame) {
// 		// setShowBanner(true);
// 		// cookie.save("_first_time_game", true, { path: "/", expires: moment().add(1, "months").toDate() });
// 		// }
// 		// else {
// 		// 	setShowWoay(false);
// 		// }

// 		// if (cookieSummerGame === "true") {
// 		// 	cookie.remove("_summer_game", { path: "/" });
// 		// 	cookie.remove("_summer_game", { path: "/", domain: ".mioto.vn" });
// 		// 	if (cookieWauthGame !== undefined) {
// 		// 		toggleWoayModal();
// 		// 		cookie.remove("_wauth_game", { path: "/" });
// 		// 		cookie.remove("_wauth_game", { path: "/", domain: ".mioto.vn" });
// 		// 	} else if (!cookieFirstTimeGame) {
// 		// 		setShowBanner(true);
// 		// 		cookie.save("_first_time_game", true, { path: "/", expires: moment().add(1, "months").toDate() });
// 		// 	} else if (cookieFirstTimeGame === "true") {
// 		// 		toggleWoayModal();
// 		// 	}
// 		// } else {

// 		// }
// 	}, []);

// 	const toggleWoayModal = () => {
// 		setShowWoay(!showWoay);
// 		onFixHeight(!showWoay);
// 	};

// 	const toggleWoayBanner = () => {
// 		setShowBanner(!showBanner);
// 	};

// 	return (
// 		<div className="bottom-fixed">
// 			{showCTA && (
// 				<a className="feedback" onClick={toggleWoayModal}>
// 					<img src={mini_game} />
// 					<span
// 						style={{
// 							position: "absolute",
// 							top: 0,
// 							right: 0,
// 							background: "#5fcf86",
// 							color: "#ffffff",
// 							fontSize: "26px",
// 							lineHeight: 0.5,
// 							padding: "4px",
// 							fontWeight: 800,
// 							borderRadius: "100%",
// 						}}
// 						onClick={closeCTAHandle}>
// 						×
// 					</span>
// 				</a>
// 			)}
// 			<WoayModal showWoay={showWoay} toggleWoayModal={toggleWoayModal} />
// 			<WoayBanner showBanner={showBanner} toggleWoayBanner={toggleWoayBanner} toggleWoayModal={toggleWoayModal} />
// 		</div>
// 	);
// };

	{/* <a href={linkApp} onClick={isIOS ? onIOSAppClick : onAndroidAppClick} className="install-mobile" target="_blank">
				<img src={install_mobile} />
				<p className="textAlign-center">
					Trải nghiệm trọn vẹn
					<br />
					Cùng ứng dụng Mioto
				</p>
				<p className="close" onClick={closeAppInstallHandle}>
					×
				</p>
			</a> */}
			{/* <WoayModal showWoay={showWoay} toggleWoayModal={toggleWoayModal} />
			<WoayBanner showBanner={showBanner} toggleWoayBanner={toggleWoayBanner} toggleWoayModal={toggleWoayModal} /> */}
	
	
	// const closeCTAHandle = (e) => {
	// 	e.stopPropagation();
	// 	setShowCTA(false);
	// };

	// const toggleWoayModal = () => {
	// 	setShowWoay(!showWoay);
	// 	onFixHeight(!showWoay);
	// };

	// const toggleWoayBanner = () => {
	// 	setShowBanner(!showBanner);
	// };
